<span
  class="tw-mb-1 tw-ml-1 tw-block tw-text-sm tw-font-semibold tw-leading-5 tw-text-slate-600"
  aria-hidden="true"
  data-cy="filter-dropdown-caption"
  >{{ caption() }}</span
>
<div class="tw-relative">
  <select
    #select
    class="tw-box-border tw-w-full tw-cursor-pointer tw-appearance-none tw-truncate tw-rounded-xl tw-border tw-border-solid tw-bg-white tw-py-[10px] tw-pl-4 tw-pr-10 tw-text-base tw-font-semibold tw-leading-6 hover:tw-bg-[#f7f8fa] focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-[#2a313d] sm:tw-max-w-[280px] lg:tw-py-3"
    [class.tw-border-[#d7dee7]]="!isSet()"
    [class.tw-text-[#4d5766]]="!isSet()"
    [class.tw-border-[#2a313d]]="isSet()"
    [class.tw-text-[#2a313d]]="isSet()"
    [class.tw-shadow-[inset_0_0_0_1px_#2a313d]]="isSet()"
    [attr.aria-label]="label()"
    (change)="optionSelected.emit(select.value)">
    @for (option of options(); track option.value) {
      <option [value]="option.value" [selected]="option.value === value()">{{ option.label }}</option>
    }
  </select>
  <ate-icon
    name="chevron-down-v2"
    aria-hidden="true"
    class="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-4 tw-my-auto tw-size-4"
    [class.tw-text-[#4d5766]]="!isSet()"
    [class.tw-text-[#2a313d]]="isSet()"></ate-icon>
</div>
